if (!customElements.get('cart-add-on')) {
  customElements.define(
    'cart-add-on',
    class CartAddOn extends HTMLElement {
      constructor() {
        super();

        const addToCartButton = this.querySelector('.cart-add-on__button');
        addToCartButton?.addEventListener('click', this.addToCart.bind(this));
      }

      addToCart() {
        const variantID = this.getAttribute('variant-id');

        const body = JSON.stringify({
          items: [{ id: variantID, quantity: 1 }],
          sections: [
            ...new Set(
              this.getSectionsToRender()
                .map((section) => section.section)
                .filter(Boolean),
            ),
          ],
          sections_url: window.location.pathname,
        });

        console.log(window.routes.cartAddUrl, this.fetchConfig(), body);

        fetch(window.routes.cartAddUrl, { ...this.fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id)?.querySelector(section.selector) ||
                document.getElementById(section.id);

              if (elementToReplace && section.section) {
                elementToReplace.innerHTML =
                  this.getSectionInnerHTML(parsedState.sections[section.section], section.selector, section.id) || '';
              }
            });
          })
          .catch(() => {})
          .finally(() => {});
      }

      fetchConfig(type = 'json') {
        return {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
        };
      }

      /**
       *
       * @param {string} html
       * @param {string} selector
       * @param {string} [id] - Scopes the selector, needed when several parts share one section (e.g. main-cart-mobile-a-b-test)
       * @returns {string | undefined}
       */
      getSectionInnerHTML(html, selector, id) {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        return ((id && doc.querySelector(`#${id} ${selector}`)) || doc.querySelector(selector))?.innerHTML;
      }

      /**
       *
       * @returns {Array<{id: string, section: string | undefined, selector: string}>}
       */
      getSectionsToRender() {
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items')?.dataset.id,
            selector: '.js-contents',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'main-cart-items-add-ons',
            section: document.getElementById('main-cart-items-add-ons')?.dataset.id,
            selector: '.js-contents',
          },
          {
            id: 'main-cart-total',
            section: document.getElementById('main-cart-total')?.dataset.id,
            selector: '.js-contents',
          },
          {
            id: 'cart-pre',
            section: document.getElementById('cart-pre')?.dataset.id,
            selector: '.js-contents',
          },
        ];
      }
    },
  );
}
